import { AppConstants} from "@/common";

export default defineNuxtPlugin(async () => {
  
  function getClientAppVersion() {
    return localStorage.getItem(AppConstants.keyCacheBrowser) ?? '0';
  }
  
  function setClientAppVersion(latestVersion: string) {
   return localStorage.setItem(AppConstants.keyCacheBrowser, latestVersion);
  }
  
  const version = Date.now();

  fetch(`/cache-version.json?${version}`).then((serverPromise) => {
    serverPromise.json().then((response) => {
      const latestVersion = response.version;
      const clientStoredVersion = getClientAppVersion();

      if (latestVersion == undefined || clientStoredVersion == 'undefined') {
        console.error("Unable to check browser cache version");
        return;
      }

      if (clientStoredVersion != latestVersion) {
        setClientAppVersion(latestVersion);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore:next-line
        window.location.reload(true);
      } else {
        return;
      }
    }).catch((error) => {
      console.error("Unable to check browser cache version", error);
    });
  }).catch((error) => {
      console.error("Cache version fetch  error", error);
    }
  );
});